import React, { useEffect, useState } from 'react'
import { CCol, CForm, CFormInput, CFormLabel, CRow } from '@coreui/react'
import { Dialog } from 'primereact/dialog'
import { Checkbox } from 'primereact/checkbox'
import { Button } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { usePrinter } from '../contexts/PrinterContext'
import CInput from './CInput'
import CSelect from './CSelect'
import FloorSelection from './FloorSelection'
import PrinterCategorySelection from './PrinterCategorySelection'

const printerTypes = [
    { value: "Kitchen", label: "Kitchen" },
    { value: "Bar", label: "Bar" },
    { value: "Admin", label: "Admin" },
]

function AddPrinter({ visible, editMode, editPrinterId, handleClose, fetchPrinters, canAccessBackupPrinterIp }) {
    const { getSinglePrinter, createPrinter, updatePrinter } = usePrinter();
    const { restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);
    const [floorValidated, setFloorValidated] = useState(false)
    const [printerDetail, setPrinterDetail] = useState({
        name: '',
        type: '',
        ip_address: '',
        backup_ip_address: '',
        no_of_prints: 1,
        send_to_both: 0,
        restaurant_id: restaurantId,
        floor_id: null,
        categories: [],
    });

    useEffect(() => {
        fetchSinglePrinter();
    }, [editMode, editPrinterId]);

    const fetchSinglePrinter = async () => {
        if (editPrinterId) {
            const printer = await getSinglePrinter(editPrinterId)
            if (printer) {
                setPrinterDetail(printer.data);
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);
        printerDetail.floor_id.value ? setFloorValidated(false) : setFloorValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                const selectedCategories = printerDetail?.categories?.length > 0 ? printerDetail.categories.map(category => category.value) : []
                const selectedFloorId = printerDetail?.floor_id?.value ? printerDetail.floor_id.value : null;

                if (visible && restaurantId && selectedFloorId) {
                    const data = await createPrinter({ ...printerDetail, restaurant_id: restaurantId, categories: selectedCategories, floor_id: selectedFloorId });
                    if (!data.error) {
                        handleClose();
                        setPrinterDetail({
                            name: '',
                            type: '',
                            ip_address: '',
                            no_of_prints: 1,
                            send_to_both: 0,
                            restaurant_id: restaurantId,
                            categories: []
                        });
                        setFloorValidated(false);
                        setValidated(false);
                        fetchPrinters();
                    }
                } else if (editMode && editPrinterId && restaurantId && selectedFloorId) {
                    const data = await updatePrinter(editPrinterId, { ...printerDetail, restaurant_id: restaurantId, categories: selectedCategories, floor_id: selectedFloorId });
                    if (!data.error) {
                        handleClose();
                        setPrinterDetail({
                            name: '',
                            type: '',
                            ip_address: '',
                            no_of_prints: 1,
                            send_to_both: 0,
                            restaurant_id: restaurantId,
                            categories: []
                        });
                        setFloorValidated(false);
                        setValidated(false);
                        fetchPrinters();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    console.log(printerDetail);
    
    return (
        <div>
            <Dialog draggable={false} header={`${visible ? 'Create Printer' : 'Edit Printer'}`} visible={visible || (editMode && editPrinterId !== null)} style={{ width: '30vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className="mb-3 mt-3">
                            <CInput
                                label="Name"
                                type="text"
                                value={printerDetail.name}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, name: value })}
                                required={true}
                                errorMessage='Name is required.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CSelect
                                label="Type"
                                labelClassName='w-50'
                                options={printerTypes}
                                value={printerDetail.type}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, type: value })}
                                required={true}
                                errorMessage='Printer type is required.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CInput
                                label="Printer IP"
                                type="text"
                                value={printerDetail.ip_address}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, ip_address: value })}
                                required={true}
                                errorMessage='Printer IP is required.'
                            />
                        </CRow>
                        {canAccessBackupPrinterIp &&
                            <CRow className="mb-3">
                                <CInput
                                    label="Backup Printer IP"
                                    type="text"
                                    value={printerDetail.backup_ip_address}
                                    onChange={(value) => setPrinterDetail({ ...printerDetail, backup_ip_address: value })}
                                    required={false}
                                    errorMessage='Backup Printer IP is required.'
                                />
                            </CRow>
                        }
                        <CRow className="mb-3">
                            <div className='d-flex flex-column'>
                                <div className='w-50'>
                                    <CFormLabel className="form-label">Number Of Prints <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        min={0}
                                        value={printerDetail.no_of_prints}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue >= 0) {
                                                setPrinterDetail({ ...printerDetail, no_of_prints: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Number Of Prints is required.'
                                    />
                                </div>
                            </div>
                        </CRow>
                        <CRow className="mb-4">
                            <FloorSelection
                                className='d-flex flex-column'
                                labelClassName='w-50'
                                value={printerDetail.floor_id}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, floor_id: value })}
                                multiSelect={false}
                                required={true}
                                error={floorValidated}
                                label="Floor"
                            />
                        </CRow>
                        <CRow className="mb-4">
                            <PrinterCategorySelection
                                className='d-flex flex-column'
                                labelClassName='w-50'
                                value={printerDetail.categories}
                                onChange={(value) => setPrinterDetail({ ...printerDetail, categories: value })}
                                floorId={printerDetail.floor_id?.value}
                                multiSelect={true}
                                label="Categories"
                                disabled={printerDetail.type === 'Admin' || !printerDetail.floor_id?.value}
                            />

                        </CRow>
                        <CRow className='mb-4'>
                            <CCol lg={4}>
                                <CFormLabel className="form-label pt-1">Send To Both</CFormLabel>
                            </CCol>
                            <CCol lg={8} className="custom-checkbox mx-0 px-0">
                                <Checkbox
                                    checked={printerDetail.send_to_both === 1}
                                    onChange={(event) => setPrinterDetail({ ...printerDetail, send_to_both: event.target.checked ? 1 : 0 })}
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <div className="d-flex p-jc-end justify-content-end button-container">
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                Submit
                            </Button>
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddPrinter